import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
    FormHelperText,
	NativeSelect,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const InventoryTransaction = props => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
    const [downloadFlag, setDownloadFlag] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [searchBy, setSearchBy] = useState(null);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
    const classes = useStyles();
   
    //const [itLoc, setitLoc] = useState([]); //for data of location dropdown
    //const [locFilter, setlocFilter] = useState(2); //for location dropdown
    //const [locFilter, setlocFilter] = useState('');

    // const [itInv, setitInv] = useState([]); //for data of inventory dropdown
    // const [invFilter, setinvFilter] = useState(1); //for inventory dropdown
    
    const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));
    
    const [locId, setlocId] = useState(''); //loc id for new loc dropdown
    const [loc, setLoc] = useState([]); //for new loc dropdown

    const [invId, setinvId] = useState(''); //inv id for new inv dropdown
    const [inv, setInv] = useState([]); //for new inv dropdown
    const [itemName, setItemName] = useState(null); //for new inv dropdown

	// Data Fetching
	useEffect(() => {
		data();
    }, []);

    const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

    useEffect(() => {
        if(posts.length > 0){
            setDownloadFlag(true);
        }
    }, [posts,itemName]);

    //search button
	const dataFilter = async () => {
        if(searchBy==='id' && invId=='') {
            return;
        }
        if(invId=='0') {
            return;
        }
        const result = await axios.get(
            // `${baseUrl}/it_report`, {
                `${process.env.REACT_APP_API_URL}/get_inv_transaction`, {
            params:{
                // date_from:2021-01-01
                // date_to:2021-03-05
                // jc_user_id_no:DAVAOHQ
                // location_id:All
                // item_id:1165
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                location_id: locId, //location id
                item_id: invId, //inventory id
                jc_user_id_no: branchidNo,  //branchidNo
            }
        })
        setPosts(result.data.data.table_data);
        setItemName(result.data.itemname);
    }
    
 
    const data = async () => {
            //get data for location dropdown
            await axios.get(`${process.env.REACT_APP_API_URL}/get_warehouse_list`)
            .then(function (res) {
                const allLocation= {
                    id: "All",
                    description: "All Location",
                };
                  res.data.data.unshift(allLocation);
                setLoc(res.data.data);
              }).catch(function (error) {	
                // console.log(error);
              });  
            //get data for inventory dropdown
            await axios.get(`${process.env.REACT_APP_API_URL}/get_items_for_dropdown`)
            .then(function (res) {
                setInv(res.data.data);
              }).catch(function (error) {	
                // console.log(error);
              });  
              setDataLoaded(true);	
    };
const SearchBy  = [
    {      value: "id",
      description: "ID"},
        {      value: "name",
      description: "Name"}
];
    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };

    const selectLocationProps = {
		options: loc,
		getOptionLabel: (option) => option.description
    };
    const selectSearchByProps = {
		options: SearchBy,
		getOptionLabel: (option) => option.description
    };
    
    const selectInventoryProps = {
		options: inv,
		getOptionLabel: (option) => option.itemname
	};
    
    const columns = [
            {
                name: "date",
                label: "Date",
                options: {
                },
            },
            {
                name: "description",
                label: "Description",
                options: {
                },
            },
            {
                name: "in",
                label: "In",
                options: {
                },
            },
            {
                name: "out",
                label: "Out",
                options: {
                },
            },
            {
                name: "location",
                label: "Location",
                options: {
                },
            },
            {
                name: "refid",
                label: "Actions",
                    options: {
                        sort:false, 
                        filter: false, 
                        customBodyRenderLite: (dataIndex) => {
                            let reftype =  posts[dataIndex].reftype;
                            let refid =  posts[dataIndex].refid;
                            let idno =  posts[dataIndex].idno;
                            //return poretno + " " + allocateall;

                            //temporarily commented out navlinks
                            if(reftype === "DR"){ //salesorderviewreference.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6} lg={6} xl={4}>
                                        <NavLink to={"/sales/sales-order-history-view-ref/"+refid+"/"+branchidNo}>
                                            <Button variant="contained" color="primary">
                                                View
                                            </Button>	
                                        </NavLink> 
                                        </Grid>
                                    </Grid>
                                );
                            }else if(reftype ==="Sales Return"){ //salesreturnview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
										    <NavLink to={"/sales/sales-return-history-view/"+refid+"/"+branchidNo}>
										    	<Button variant="contained" color="primary">
										    		View
										    	</Button>	
										    </NavLink> 
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype==="PRF"){ //packagereleaseview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                <Button variant="contained" color="primary">
                                                    View PRF
                                                </Button>	
                                               {/* </NavLink>  */}
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype=="PPF"){ //packagepulloutview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                <Button variant="contained" color="primary">
                                                    View PPF
                                                </Button>	
                                               {/* </NavLink>  */}
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype=="Inventory Receiving"){ //poreceiveviewreference.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                        <NavLink to={"/purchases/purchases-order-reference-view/"+refid+"/"+branchidNo}>
                                                <Button variant="contained" color="primary">
                                                    View IR
                                                </Button>	
                                               </NavLink> 
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype=="PO Return"){ //purchasereturnview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <NavLink to={"/purchases/purchases-order-allocate-view/"+refid+"/"+branchidNo}>	
													<Button variant="contained" color="primary">
														View
														{/* get_returned_po_details */}
													</Button>	
												</NavLink> 
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype=="ILT"){ //iltview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                <Button variant="contained" color="primary">
                                                    View ILT
                                                </Button>	
                                               {/* </NavLink>  */}
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype=="Inventory Adjustment"){ //invadjview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                        <NavLink to={"/inventory/inventory-adjustment-history-view/"+refid+"/"+branchidNo}>
                                            <Button variant="contained" color="primary">
                                                View INV ADJ
                                            </Button>	
                                        </NavLink> 
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype=="BOM"){ //builditemsview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                <Button variant="contained" color="primary">
                                                    View BOM
                                                </Button>	
                                               {/* </NavLink>  */}
                                        </Grid>
                                    </Grid>
                                );	
                            }else if(reftype==="DISTRIBUTOR"){ //builditemsview.php  
                                //let isOP = substr(refid, 0, 2); //look for js equiv of php substr
                                let isOP = refid?.substring(0, 2); //look for js equiv of php substr
                                if(isOP==="OP"){ //packagesalesprintweb.php
                                    return (
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                    <Button variant="contained" color="primary" >
                                                        View DIST
                                                    </Button>	
                                                   {/* </NavLink>  */}
                                            </Grid>
                                        </Grid>
                                    );	
                                }else{ //packagesalesviewprint.php
                                    return (
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                            <NavLink to={"/package-sales-view/"+idno}>	
                                                    <Button variant="contained" color="primary">
                                                        View
                                                    </Button>	
                                                   </NavLink> 
                                            </Grid>
                                        </Grid>
                                    );	
                                }
                            }else if(reftype==="Package Purchase"){ 
                                //substr(refid, 0, 2)
                                let isOP = refid.substring(0, 2); //look for js equiv of php substr
                                if(isOP==="OP"){ //packagesalesprintweb.php
                                    return (
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                    <Button variant="contained" color="primary">
                                                        View PCKP
                                                    </Button>	
                                                   {/* </NavLink>  */}
                                            </Grid>
                                        </Grid>
                                    );	
                                }else{ //packagepurchaseview_rcvcopy.php
                                    return (
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                    <Button variant="contained" color="primary">
                                                        View PCK
                                                    </Button>	
                                                   {/* </NavLink>  */}
                                            </Grid>
                                        </Grid>
                                    );	
                                }
                            }else{ //repsubsidyview.php
                                return (
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            {/* <NavLink to={"/purchases/purchases-order-approval-history-view/"+pono+"/"+useridNo}> */}
                                                <Button variant="contained" color="primary">
                                                    View rep
                                                </Button>	
                                               {/* </NavLink>  */}
                                        </Grid>
                                    </Grid>
                                );	
                            }
                        },
                        download: false //exclude this column in csv export
                    }
                },
                // $echo.='<td class="actions">';
                // $echo.='<div class="action-buttons">';
                // if($rowrecord["reftype"]=="DR")
                // {
                //     $echo.='<a class="table-actions" href="salesorderviewreference.php?sono='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="Sales Return")
                // {
                //     $echo.='<a class="table-actions" href="salesreturnview.php?drretno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="PRF")
                // {
                //     $echo.='<a class="table-actions" href="packagereleaseview.php?pkno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="PPF")
                // {
                //     $echo.='<a class="table-actions" href="packagepulloutview.php?pulno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="Inventory Receiving")
                // {
                //     $echo.='<a class="table-actions" href="poreceiveviewreference.php?rcvno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="PO Return")
                // {
                //     $echo.='<a class="table-actions" href="purchasereturnview.php?poretno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="ILT")
                // {
                //     $echo.='<a class="table-actions" href="iltview.php?iltno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="Inventory Adjustment")
                // {
                //     $echo.='<a class="table-actions" href="invadjview.php?adjno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="BOM")
                // {
                //     $echo.='<a class="table-actions" href="builditemsview.php?buildno='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // else if($rowrecord["reftype"]=="DISTRIBUTOR")
                // {
                //     $isOP = substr($rowrecord["refid"], 0, 2);
                //     if($isOP=="OP")
                //     {
                //         $echo.='<a class="table-actions" href="packagesalesprintweb.php?idno='.$rowrecord["idno"].'"><i class="fa fa-eye"></i></a>';
                //     }
                //     else
                //     {
                //         $echo.='<a class="table-actions" href="packagesalesviewprint.php?idno='.$rowrecord["idno"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                //     }
                // }
                // else if($rowrecord["reftype"]=="Package Purchase")
                // {
                //     $isOP = substr($rowrecord["refid"], 0, 2);
                //     if($isOP=="OP")
                //     {
                //         $echo.='<a class="table-actions" href="packagesalesprintweb.php?idno='.$rowrecord["idno"].'"><i class="fa fa-eye"></i></a>';
                //     }
                //     else
                //     {
                //         $echo.='<a class="table-actions" href="packagepurchaseview_rcvcopy.php?recid='.$rowrecord["idno"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                //     }
                // }
                // else if($rowrecord["reftype"]=="Subsidy")
                // {
                //     $echo.='<a class="table-actions" href="repsubsidyview.php?refid='.$rowrecord["refid"].'" target="_blank"><i class="fa fa-eye"></i></a>';
                // }
                // $echo.='</div>';
                // $echo.='</td>';
                // $echo.='</tr>';
                // $count++;
        ];

        const options = {
            filter: false,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "multiselect",
            responsive: "standard",
            
            setFilterChipProps: (colIndex, colName, data) => {
           
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
            download: false,  //add this
            print: false,
            viewColumns: false, //add this
			downloadOptions: {
				filename : 'InventoryTransaction.csv' //change filename of csv
			}
        };

        const style = {
            marginBottom: '1rem',
        };

        return (
            <div className="page">
            <div className="page-header">
                <div className="page-icon">
                    <AssessmentTwoTone />
                </div>
                <NavLink to={"/reports"}><h2 style={{color:"black"}}>Reports</h2></NavLink>
                <ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
                <h2 className="header-title">Inventory Transaction Report</h2>
            </div>
            <div className="page-container">		
                <div style={style}>
                    <Grid container spacing={1} style={{alignContent:'center'}}>
                    <Grid item xs={12} md={4} lg={3} xl={3}>
                            <TextField
                                id="outlined-basic"
                                label="Select Date"
                                variant="outlined"
                                onFocus={() => setOpen(true)}
                                autoComplete="off"
                                value={`${format(
                                    dateRange.startDate,
                                    "MM/dd/yyyy"
                                )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                            />
                            <DateRangePicker
                                open={open}
                                toggle={toggle}
                                onChange={(range) => dateRangeHandler(range)}
                            /> 
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <Autocomplete
                                {...selectSearchByProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                style ={{marginTop: "-15px"}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="normal"
                                        label="Search By"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    if (!newValue == "" || !newValue == null){
                                    
                                        setSearchBy(newValue.value);
                                    }else{
                                        setSearchBy(null);
                                    }
                                }}
                            />     
                        </Grid>

                        <Grid item xs={2} md={2} lg={2}>
                            <Autocomplete
                                {...selectLocationProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                style ={{marginTop: "-15px"}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="normal"
                                        label="Select Location"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    if (!newValue == "" || !newValue == null){
                                      
                                        setlocId(newValue.id);
                                    }
                                }}
                            />     
                        </Grid>

{searchBy == "id"&&(<Grid item xs={3} md={3} lg={3}>
                        <div  style ={{marginTop: "-15px"}}>
                            <TextField
                            type="number"
                                margin="normal"
                                label="ID"
                                variant="outlined"
                                required={false}
                                 onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e') e.preventDefault();
                                }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                if (val != '' || Number(val) >= 1) {
                                setinvId(val);
                                }
                                }}
                            />
                        </div>


                        </Grid>)}
                        {searchBy == "name"&&(<Grid item xs={12} md={12} lg={4}>
                            <Autocomplete
                                {...selectInventoryProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                style ={{marginTop: "-15px"}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="normal"
                                        label="Select Inventory"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    if (!newValue == "" || !newValue == null){
                                    
                                        setinvId(newValue.item_id);
                                    }
                                }}
                            />     
                        </Grid>)}

                        {/* <Grid item xs={2} style={{marginBlock: "auto"}}>
                            <Input placeholder="Branch ID No" inputProps={{ 'aria-label': 'description' }} onChange={e => setbranchidNo(e.target.value)}/>
                        </Grid> */}
                        <Grid item xs={1}  style={{"marginTop":"8px"}}>
                            <Button variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                        </Grid>
                    </Grid>        
                </div>
                
                {!dataLoaded ? (
                    <Preloader />
                ) : (
                    <MUIDataTable
                        title={
                            <div>
                                <div className="table-subtitle">Inventory Ending Report</div>
                                <div className="table-title">
                                {itemName &&(itemName)}
                                </div>
                            </div>
                        }
                        data={posts}
                        columns={columns}
                        options={options}
                    />
                )}
            </div>
        </div>
            	);
};

export default InventoryTransaction;